/** The leaderboard became the Hall of Fame; keep old links working. */
import { Redirect } from 'expo-router'

export default function LeaderboardRedirect() {
  return <Redirect href="/(app)/hof" />
}
